import { RootState } from '../../types.ts';

export const selectReferenceBarUI = (state: RootState) => state.referenceBarUI;

export const selectHoveredPropertyGridCellKey = (state: RootState) =>
  state.referenceBarUI.hoveredPropertyGridCellKey;

export const selectHoveredOrderDetailsFieldKey = (state: RootState) =>
  state.referenceBarUI.hoveredOrderDetailsFieldKey;

export const selectHoveredCostApproachPropertyId = (state: RootState) =>
  state.referenceBarUI.hoveredCostApproachPropertyId;
